
const chinaHeadquarters = [
  {
    title: "CHINA HEADQUARTERS",
    phone: "029-89315850",
    email: "Tennyson@somyshare.com",
    address:
      "Building B, National Digital Publishing Base, Tiangu 7th Road, Xi'an City",
    src: "/img/i1.webp",
  },
  {
    title: "CHINA HEADQUARTERS",
    phone: "029-89315850",
    email: "Tennyson@somyshare.com",
    address:
      "Building B, National Digital Publishing Base, Tiangu 7th Road, Xi'an City",
    src: "/img/i2.webp",
  },
  {
    title: "CHINA HEADQUARTERS",
    phone: "029-89315850",
    email: "Tennyson@somyshare.com",
    address:
      "Building B, National Digital Publishing Base, Tiangu 7th Road, Xi'an City",
    src: "/img/i3.webp",
  },
];
const companyContactInfo = [
  {
    key: "address",
    type: "COMPANY LOCATION",
    content: "",
    src: require("@/static/img/i1.webp"),
  },
  {
    key: "WhatsApp",
    type: "WhatsApp",
    content: "",
    src: require("@/static/img/i2.webp"),
  },
  //   {
  //     key: "WhatsApp",
  //     type: "COMPANY WHATSAPP",
  //     content:"",
  //   },
  {
    key: "email",
    type: "E-MAIL ADDRESS",
    content: "",
    src: require("@/static/img/i3.webp"),
  },
];

export default {
  data() {
    return {
      chinaHeadquarters,
      companyContactInfo,
    };
  },
  created() {
    this.companyContactInfo.map(v => {
      if (v.key == "WhatsApp") {
        v.content = this.$store.state.footerData.contactShare[v.key];
      } else {
        v.content = this.$store.state.baseInfo[v.key];
      }
      return v;
    });
  },
  methods: {
    formater(text) {
      if (text && Array.isArray(text)) {
        return text.join("or<br/>");
      }
      return text;
    },
  },
};
